import script from "./AppMain.vue?vue&type=script&setup=true&lang=js"
export * from "./AppMain.vue?vue&type=script&setup=true&lang=js"

import "./AppMain.vue?vue&type=style&index=0&id=1ebe216e&lang=less&scoped=true"

import exportComponent from "/Users/lily/Documents/local/v-7pa-xling/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ebe216e"]])

export default __exports__